import { render, staticRenderFns } from "./SubUnitEdit.vue?vue&type=template&id=43268be0&scoped=true&"
import script from "./SubUnitEdit.vue?vue&type=script&lang=ts&"
export * from "./SubUnitEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43268be0",
  null
  
)

export default component.exports